import { createContext, useContext } from 'react';
export var VisibleActionContext = /*#__PURE__*/createContext(undefined);
export var useVisibleActionContext = function useVisibleActionContext() {
  var context = useContext(VisibleActionContext);
  if (context === undefined) {
    throw new Error('useVisibleActionContext must be used within a VisibleActionProvider component');
  }
  return context;
};